// extracted by mini-css-extract-plugin
export default {"root":"UserManagement_root__2lSVh"};